import {createSvgIcon} from '../create-svg-icon';

export const FileDownloadDoneIcon = createSvgIcon(
  <path d="M20.13 5.41 18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66zM5 18h14v2H5z" />
, 'FileDownloadDoneOutlined');
